"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const SocketQuery_1 = __importDefault(require("./SocketQuery"));
const SocketDocumentReference_1 = __importDefault(require("./SocketDocumentReference"));
class SocketCollectionReference extends SocketQuery_1.default {
    constructor(driver, id, 
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    parent) {
        super(driver, id, parent);
    }
    doc(id) {
        return new SocketDocumentReference_1.default(this, id);
    }
    async add(data) {
        const { id } = await this.driver.request('collectionAdd', this.path, data);
        return new SocketDocumentReference_1.default(this, id);
    }
}
exports.default = SocketCollectionReference;
//# sourceMappingURL=SocketCollectionReference.js.map